import { ArrowPathIcon, ArrowRightOnRectangleIcon, AtSymbolIcon, ChevronDownIcon, IdentificationIcon, UserIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch } from "app/hooks";
import { FC, Fragment, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import logoImg from "../../../assets/images/logo.jpeg";
import {
  ButtonPrimary, ButtonSecondary, ButtonThird, FloatInput, NcImage, Radio
} from "../../../components";
import Modal from "./Modal";
import { Popover, Transition } from "@headlessui/react";

// import { signIn, signOut } from "../services/AuthSlice";
// import { GET_AUTHSYSTEM } from "../services/AuthSystemSlice";

export interface PageSalihaSubmissionDetailProps {
  className?: string;
}

type SalihaSubmissionDetailForm = {
  username: string;
  password: string;
};

const LokasiPabrikRadios = [
  { name: "Dalam Negeri", id: "Dalam Negeri" },
  { name: "Luar Negeri", id: "Luar Negeri" },
];

const SalihaSubmissionDetail: FC<PageSalihaSubmissionDetailProps> = ({ className = "" }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [LokasiPabrikStates, setLokasiPabrikStates] = useState<string>("Dalam Negeri");

  let navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const _access_token = searchParams.get("access-token")

  // const [client, setClientId] = useState<boolean | null>(false)
  // const [profile, setProfile] = useState<any | null>(false)
  // const [credential, setCredential] = useState<any | null>(false)

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Email is required"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters")
      .max(40, "Password must not exceed 40 characters"),
  });

  const {
    register,
    handleSubmit,
    // reset,
    formState: { errors },
  } = useForm<SalihaSubmissionDetailForm>({
    resolver: yupResolver(validationSchema),
  });

  const renderOptionLokasiPabrik = () => {
    return (
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={`flex w-full bg-gray-50 items-center justify-between px-4 py-3 text-sm rounded-2xl border-2 focus:outline-none 
                ${open ? "border-primary-500 " : "border-gray-250"}
                `}
            >
              <span className="ml-2">
                {LokasiPabrikStates
                  ? LokasiPabrikRadios.filter((i) => i.id === LokasiPabrikStates)[0]
                    .name
                  : "Sort order"}
              </span>
              {LokasiPabrikStates.length ? (
                <ChevronDownIcon className="w-4 h-4 ml-3" />
              ) : (
                <span onClick={() => setLokasiPabrikStates("")}>
                  {/* {renderXClear()} */}
                </span>
              )}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-40 w-36 max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-xl">
                <div className="overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700">
                  <div className="relative flex flex-col px-5 py-6 space-y-5">
                    {LokasiPabrikRadios.map((item) => (
                      <Radio
                        id={item.id}
                        key={item.id}
                        name="radioNameSort"
                        label={item.name}
                        defaultChecked={LokasiPabrikStates === item.id}
                        onChange={setLokasiPabrikStates}
                      />
                    ))}
                  </div>
                  <div className="p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-between">
                    <ButtonThird
                      onClick={() => {
                        close();
                        // setIdentityTypeStates("");
                      }}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Selesai
                    </ButtonThird>
                    {/* <ButtonPrimary
                      onClick={close}
                      sizeClass="px-4 py-2 sm:px-5"
                    >
                      Apply
                    </ButtonPrimary> */}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    );
  };

  const renderContent = () => {
    return (
      <form action="#">
        {/* <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-200">
          Scan to connect
        </h3>
        <span></span> */}
        <div className="flex flex-col text-sm">
          <span className="font-bold">Pabrik / Fasilitas Produksi</span>
          <span>Lengkapi isian dibawah ini</span>
        </div>

        <form
          // onSubmit={handleSubmit(doRegister)}
          className="mt-5">
          <FloatInput
            type="text"
            id="name"
            label="Nama Pabrik atau Fasilitas Produksi"
          // {...register("name")}
          // isError={errors.name}
          // errorMessage={errors.name?.message}
          />
          <div className="mb-2"></div>
          <FloatInput
            type="text"
            id="address"
            label="Alamat"
          // {...register("username")}
          // isError={errors.username}
          // errorMessage={errors.username?.message}
          />
          <div className="mb-2"></div>

          {renderOptionLokasiPabrik()}

          <div className="mb-2"></div>

          <FloatInput
            type="text"
            id="country"
            label="Negara"
          // {...register("username")}
          // isError={errors.username}
          // errorMessage={errors.username?.message}
          />
          <div className="mb-2"></div>
          {/* <FloatInput
                  Icon={KeyIcon}
                  type="password"
                  id="password"
                  label="Kata Sandi"
                  {...register("password")}
                  isError={errors.password}
                  errorMessage={errors.password?.message}
                />
                <div className="mb-2"></div>
                <FloatInput
                  Icon={KeyIcon}
                  type="password"
                  id="confPassword"
                  label="Konfirmasi Kata Sandi"
                  {...register("confPassword")}
                  isError={errors.confPassword}
                  errorMessage={errors.confPassword?.message}
                /> */}
          {/* {isError && (
                  <>
                    <div className="mb-2"></div>
                    <div
                      className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
                      role="alert">
                      <span className="flex mr-3">
                        <XCircleIcon className="w-5 text-red-500" />
                      </span>
                      <span className="font-semibold mr-2 text-left flex-auto">
                        {errorMessage}
                      </span>
                      <svg
                        className="fill-current opacity-75 h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20">
                        <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
                      </svg>
                    </div>
                  </>
                )} */}
        </form>

        <div className="mt-5 space-x-3 flex flex-row justify-end">
          <ButtonPrimary type="submit">Install app</ButtonPrimary>
          <ButtonSecondary type="button">Cancel</ButtonSecondary>
        </div>
      </form>
    );
  };

  return (
    <div className={`nc-PageLogin bg-gray-100 ${className} `} data-nc-id="PageLogin">
      <div className="container h-screen flex w-full justify-center">

        <div className="rounded-xl bg-gray-50 w-full max-w-2xl mt-10">
          <div className="rounded-xl p-5 pb-20 text-white">
            <div className="w-full flex flex-row justify-start space-x-5 items-center">
              <img
                className={`block max-h-16`}
                src={logoImg}
                alt="Logo"
              />
              
            </div>

          </div>

          <div className="-mt-20 p-5">
            <div className="rounded-xl bg-white p-4 text-gray-600 shadow-sm">
              <div className="mb-3 text-xs md:text-sm flex flex-row justify-between">
                <div className="flex flex-col">
                  <span className="font-bold">Pabrik / Fasilitas Produksi</span>
                  <span>Tempat fasilitasi, klik baru untuk masukan fasilitas produksi</span>
                </div>
                <div>
                  <ButtonPrimary
                    onClick={() => {
                      setShowModal(true);
                      setModalTitle("Pabrik / Fasilitas Produksi")
                    }}
                    sizeClass="p-1 md:p-2 px-3"
                    className="w-full"
                    type="submit">
                    <span className="text-sm whitespace-nowrap">+ Baru</span>
                  </ButtonPrimary>
                </div>
              </div>
            </div>
          </div>


          <section className="p-5">
            <div className="flex flex-row space-x-3 w-full">
              <ButtonSecondary
                // disabled={!client}
                // loading={isFetching}
                className="w-full"
                type="button"
              >
                Keluar <XCircleIcon className="font-bold ml-5 w-6" />
              </ButtonSecondary>
              <ButtonPrimary
                // disabled={!client}
                className="w-full"
                type="button"
              >
                Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" /> <br />
              </ButtonPrimary>
            </div>
          </section>

        </div>
      </div>

      <Modal
        renderTrigger={() => null}
        isOpenProp={showModal}
        renderContent={renderContent}
        contentExtraClass="max-w-md"
        onCloseModal={() => setShowModal(false)}
        modalTitle="Connect Wallet"
      />
    </div>
  );
};

export default SalihaSubmissionDetail;
